import { useState, useEffect } from 'react';
import styles from './SplashScreen.module.css';

const SPLASH_DISMISSED_KEY = 'forge-splash-dismissed';

export function SplashScreen({ onDismiss }: { onDismiss: () => void }) {
  const handleEnter = () => {
    localStorage.setItem(SPLASH_DISMISSED_KEY, 'true');
    onDismiss();
  };

  return (
    <div className={styles.splash}>
      <div className={styles.content}>
        <img 
          src="/forge.png" 
          alt="The Forge" 
          className={styles.logo}
        />
        <button 
          onClick={handleEnter}
          className={styles.enterButton}
        >
          Enter the forge
        </button>
      </div>
    </div>
  );
}

export function useSplashScreen() {
  const [showSplash, setShowSplash] = useState(true);

  useEffect(() => {
    const dismissed = localStorage.getItem(SPLASH_DISMISSED_KEY);
    if (dismissed === 'true') {
      setShowSplash(false);
    }
  }, []);

  const dismissSplash = () => setShowSplash(false);

  return { showSplash, dismissSplash };
}
